import { SpinLoading, Modal, AutoCenter } from 'antd-mobile'
import closure from 'static/images/closure.png'
import './index.css'
const ConditionLoading = ({ type }) => {
  const handleCancel = () => {
    Modal.clear()
  }
  return (
    <div className={type ? 'modal-condition-loading' : 'condition-loading'}>
      {
        type && (
          <div className='condition-loading-title'>
            事项列表
            <span onClick={handleCancel}>
              <img src={closure} alt='关闭' />
              </span>
          </div>
        )
      }
      <SpinLoading color='primary' />
      <AutoCenter>
        条件检测中，请稍后...
      </AutoCenter>
      <AutoCenter>
        条件比对中，大约需要1-2分钟，请耐心等候，{type && '也可关闭本窗口浏览其他内容，'}待比对完成后查看
      </AutoCenter>
    </div>
  )
}

export { ConditionLoading }